













































import { Component, Prop, Vue } from 'vue-property-decorator'
@Component
export default class WhitelistOneShotModal extends Vue {
    @Prop({ required: true }) uploadFromFile!: {uploadfile: undefined; mode: string}

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Prop() statementEdit!: any
    @Prop() chipFile!: boolean

    chip = false
    menu = false
    loading = false
    providers = []
    carriers = []
    close () {
        this.$emit('closeModal')
    }

    validate () {
        return (this.$refs.form as Vue & { validate: () => boolean }).validate()
    }

    save () {
        if (this.validate()) {
            if (this.uploadFromFile.mode === 'Delete') {
                this.removeCsvWhitelistOneShot()
            } else {
                this.importCsvWhitelistOneShot()
            }
        }
    }

    importCsvWhitelistOneShot () {
        this.loading = true
        this.$store.dispatch('importCsvWhitelistOneShot', this.uploadFromFile)
            .then(resp => {
                if (resp.status === 200) {
                    this.$store.commit('reportSuccess', 'Done Successfully!')
                    this.$emit('loadData')
                    this.$emit('closeModal')
                } else {
                    this.$store.commit('reportError', 'File NOT save :(')
                }
                this.loading = false
            })
    }

    removeCsvWhitelistOneShot () {
        this.loading = true
        this.$store.dispatch('removeCsvWhitelistOneShot', this.uploadFromFile)
            .then(resp => {
                if (resp.status === 200) {
                    this.$store.commit('reportSuccess', 'Done Successfully!')
                    this.$emit('loadData')
                    this.$emit('closeModal')
                } else {
                    this.$store.commit('reportError', 'File NOT save :(')
                }
                this.loading = false
            })
    }

    getFileName () {
        return '.... ' + this.statementEdit.statementPath.substring(this.statementEdit.statementPath.length - 20, this.statementEdit.statementPath.length)
    }

    async mounted () {
        this.chip = this.chipFile
        // this.verifyEdit()
    }
}
